import React from 'react';
import './DashboardTile.scss';

const DashboardTile = ({ heading, content }) => {
  return (
    <div className="dashboard-tile">
      <h3>{heading}</h3>
      <p>{content}</p>
    </div>
  );
};

export default DashboardTile;